module.exports = __webpack_public_path__ + "img/bulb.a60e6a1f.png";